import "./icon.custom.objectCompany.css"
import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"

export type IconCustomObjectCompanyProps = ComponentProps<"svg">
function IconCustomObjectCompany(props: IconCustomObjectCompanyProps) {
  const { className, viewBox = "0 0 14 14", fill = "none", ...svgProps } = props

  return (
    <svg
      className={cn("objectCompany__svg", className)}
      viewBox={viewBox}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <rect
        className="objectCompany__svg_main"
        x="1"
        width="8.88889"
        height="16"
        rx="1.77778"
      />

      <path
        className="objectCompany__svg_second"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.44031 16C8.44169 16 8.44308 16 8.44447 16H13.7778C14.7596 16 15.5556 15.2041 15.5556 14.2222V5.77778C15.5556 4.79594 14.7596 4 13.7778 4H11.6667V14.2222C11.6667 15.204 10.8708 16 9.88891 16H8.44031Z"
      />
    </svg>
  )
}

export default IconCustomObjectCompany
